module.exports = __webpack_public_path__ + "static/media/card-visa.b4c085a2.svg";